module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kanagawa-3-b3cca16b264520bb2e2e27543e092d05.jpg";